export default __webpack_public_path__ + "static/media/digital-img.ebdc410c.svg";